// timerStore.js
const timerMap = new Map();

export function getOrCreateTimer(chatId, initialSeconds) {
  if (!timerMap.has(chatId)) {
    const endTime = Date.now() + initialSeconds * 1000;
    timerMap.set(chatId, endTime);
  }
  return timerMap.get(chatId);
}

export function getTimeLeft(chatId) {
  const endTime = timerMap.get(chatId);
  if (!endTime) return 0;
  const timeLeft = Math.floor((endTime - Date.now()) / 1000);
  return timeLeft > 0 ? timeLeft : 0;
}

export function clearTimer(chatId) {
  timerMap.delete(chatId);
}

